import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, data: [], error: null, total: 0, pageCount: 0 };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.GROUPS_LIST_REQUEST:
      return { ...state, loading: true, data: [], error: null };
    case CONST.GROUPS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data.data.groups,
        total: action.data.paginator.meta.total,
        pageCount: action.data.paginator.meta.last_page,
      };
    case CONST.GROUPS_LIST_ERROR:
      return { ...state, loading: false, error: action.error };
    case CONST.GROUP_CREATE_REQUEST:
      return { ...state, loading: true, error: null };
    case CONST.GROUP_CREATE_SUCCESS:
      return { ...state, loading: false, data: [...state.data, action.group.group], error: null };
    case CONST.GROUP_CREATE_ERROR:
      return { ...state, loading: false, error: action.error };
    case CONST.GROUP_EDIT_REQUEST:
      return { ...state, loading: true, error: null };
    case CONST.GROUP_EDIT_SUCCESS:
      for (const i in state.data) {
        if (state.data[i].id === action.group.id) {
          state.data[i] = action.group;
          break;
        }
      }
      return { ...state, loading: false, data: state.data, error: null };
    case CONST.GROUP_EDIT_ERROR:
      return { ...state, loading: false, error: action.error, group: null };
    default:
      return state;
  }
};
